import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { DATE_TIME_SELECTOR_TARGET_ID } from 'constant'
import UpdatingBlock from 'components/common/UpdatingBlock/UpdatingBlock'
import Section from '../Section'
import DateTimeSelector from './components/DateTimeSelector'
import model from '../viewModel'
import AppointmentDurationDisclosure from './components/DateTimeSelector/AppointmentDurationDisclosure'

const DEFAULT_TITLE = 'Select Date & Time'
const DEFAULT_ICON = 'calendar-red'

const BOTDateTimeSelector = ({
  icon = DEFAULT_ICON,
  question = '',
  title = DEFAULT_TITLE,
  hasStore,
  appointmentDataLoading = false,
  isCheckout,
  noHeading,
  threeStepper,
  skusAddedToCart,
  theme = '',
  ...props
}) => (
  <Fragment>
    <Section
      asset={ icon }
      subhead={ hasStore ? question : '' }
      title={ title }
      targetId={ DATE_TIME_SELECTOR_TARGET_ID }
      isCheckout={ isCheckout }
      threeStepper={ threeStepper }
      noHeading={ noHeading }>
      {props.isQuotePage && <AppointmentDurationDisclosure isQuotePage={ props.isQuotePage } />}
      <UpdatingBlock condition={ appointmentDataLoading }>
        <Field
          { ...props }
          { ...model.dateTimePicker }
          hasStore={ hasStore }
          isCheckout={ isCheckout }
          threeStepper={ threeStepper }
          component={ DateTimeSelector }
          props={{ theme }} />
      </UpdatingBlock>
    </Section>
  </Fragment>
)

BOTDateTimeSelector.propTypes = {
  appointmentDataLoading: PropTypes.bool,
  hasStore: PropTypes.bool,
  icon: PropTypes.string,
  isCheckout: PropTypes.bool,
  isQuotePage: PropTypes.bool,
  noHeading: PropTypes.bool,
  question: PropTypes.string,
  skusAddedToCart: PropTypes.arrayOf(PropTypes.shape()),
  theme: PropTypes.string,
  threeStepper: PropTypes.bool,
  title: PropTypes.string
}

export default BOTDateTimeSelector
